import { useState } from 'react';

import type { Company } from '@/types';
import type { FC } from 'react';

import AdminCompanyEditDialog from '@/features/companyDashboard/common/AdminCompanyEditDialog';
import CompanyInfoPanel from '@/features/companyDashboard/common/CompanyInfoPanel';

const OpsCompanyInfo: FC<{
  company: Company;
  isCollapsed?: boolean;
  onCollapsedChange?: (isCollapsed: boolean) => void;
}> = ({ company, isCollapsed, onCollapsedChange }) => {
  const [isEditing, setIsEditing] = useState(false);

  const onEditing = () => setIsEditing(true);
  const onCloseEditing = () => setIsEditing(false);

  return (
    <CompanyInfoPanel
      company={company}
      editDialog={
        isEditing ? (
          <AdminCompanyEditDialog company={company} onClose={onCloseEditing} />
        ) : null
      }
      isCollapsed={isCollapsed}
      onCollapsedChange={onCollapsedChange}
      onEdit={onEditing}
    />
  );
};

export default OpsCompanyInfo;
